import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "../../api";
import { IDS } from "../../IDS";

export const getBelowGraphData = async (company_id, status) => {
  try {
    return await getData(
      `/website/below-graph-data/${company_id}?status=${status}`
    );
  } catch (error) {
    console.log(error);
  }
};
